import { render, staticRenderFns } from "./TextInfoSection.vue?vue&type=template&id=63a3ae6e&scoped=true"
import script from "./TextInfoSection.vue?vue&type=script&lang=ts"
export * from "./TextInfoSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3ae6e",
  null
  
)

export default component.exports